import { InjectionToken, Type } from '@angular/core';
import type { SurfaceContextHandle } from '../../core/runtime/surface.context/create.surface.context.options';

/** Optional entity-owned component mounted in the Manage surface's existing left column. */
export interface ManageSurfaceLeftRail {
  readonly component: Type<unknown>;
  readonly visible?: (model: Readonly<Record<string, unknown>>) => boolean;
  readonly inputs?: (handle: SurfaceContextHandle) => Readonly<Record<string, unknown>>;
}

export const MANAGE_SURFACE_LEFT_RAIL = new InjectionToken<ManageSurfaceLeftRail>('MANAGE_SURFACE_LEFT_RAIL');
